module.exports = __webpack_public_path__ + "img/1565926100.1763a5e2.jpg";